import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type State = {
    selectedModalName: string;
    pageModel: any;
};

const initialState: State ={ selectedModalName: '', pageModel: ''}

const modalSlice = createSlice<State,{},"modal"> ({
    name:"modal",
    initialState:initialState ,
    reducers: {
        showModal(state,action: PayloadAction<string>) {
            state.selectedModalName = action.payload;
        },
        closeModal(state) {
            state.selectedModalName = '';
        },
    }
    });


export const {showModal, closeModal} = modalSlice.actions
export default  modalSlice.reducer;
